// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"snackbar__msignaturepad___jOU9E","m-signature-pad--body":"snackbar__m-signature-pad--body___3N5H_","m-signature-pad--footer":"snackbar__m-signature-pad--footer___3B3qP","description":"snackbar__description___5daR_","button":"snackbar__button___31IKB","clear":"snackbar__clear___2DWLH","save":"snackbar__save___1B3ej","m-signature-pad":"snackbar__m-signature-pad___13p7z","github":"snackbar__github___13886","label":"snackbar__label___2zRzh","warning":"snackbar__warning___2qiHT","accept":"snackbar__accept___2gaa8"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/snackbar.scss
// module id = NwYq
// module chunks = client